import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { MapDispatchToProps, MapStateToProps } from '~commonInfra/utils/ConnectUtils';
import { contentCountsRequest } from '~src/spacesPlatform/actions/ContentCountsActions';
import { selectMixedContentFilterClauses, selectSearchText } from '~src/spacesPlatform/selectors/ContentFilterSelectors';
import { selectContentTotalLength } from '~src/spacesPlatform/selectors/ContentSelectors';

import { siteUrlsSelector } from '../../bootstrap/redux/selectors/SiteUrlsSelectors';
import { AppState } from '../../bootstrap/redux/state/AppState';
import { UnifiedSearchSpace, UnifiedSearchSpaceDispatchProps, UnifiedSearchSpaceOwnProps, UnifiedSearchSpaceStateProps } from './UnifiedSearchSpace';

const mapStateToProps: MapStateToProps<UnifiedSearchSpaceStateProps> = (state: AppState) => ({
  urls: siteUrlsSelector(state),
  searchTerm: selectSearchText(state),
  contentFilters: selectMixedContentFilterClauses(state),
  fetchedContentCount: selectContentTotalLength(state),
  isFetchingContent: state.contentExplorer.content.isBusy,
});

const mapDispatchToProps: MapDispatchToProps<UnifiedSearchSpaceDispatchProps> =
  (dispatch) => bindActionCreators({
    fetchUpdatedContentCounts: contentCountsRequest
  },
  dispatch);

export const ConnectedUnifiedSearchSpace: React.ComponentClass<UnifiedSearchSpaceOwnProps>
  = connect(mapStateToProps, mapDispatchToProps)(UnifiedSearchSpace);
